exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".application-delete-modal .modal-dialog{width:350px}.applications .delete-success{max-width:1440px;margin:8px auto;width:96%;border:1px solid #4571cc;border-radius:5px;background:#e0e7f6;padding:14px 55px 14px 2%;position:relative;display:block;color:#4571cc}@media (max-width:768px){.application-delete-modal .modal-dialog{position:absolute;top:20%;width:95%;left:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./directives/applicationDeleteModal/applicationDeleteModal.css
// module id = 540
// module chunks = 0